import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { AcessoService } from '../../service/acesso/acesso.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';



export interface CompraBeneficioCompleto {
  Sigla: string;
  Empfil: number;
  CodigoBeneficio: number;
  AnoMes: string;
  CodUsuario: string;
  itens: {
    Numord: number;
    Quantidade: number;
  }[];
}

export interface AtualizarItemRequest {
  Sigla: string;
  AnoMes: string;
  Empfil: number;
  Numord: number;
  ValorDia: number;
  DiasNecessarios: number;
  CodigoCompraBeneficio: number;
  Quantidade: number;
}

@Injectable({ providedIn: 'root' })
export class CompraBeneficiosService {
  private readonly relatoriosBase = 'https://api-relatorios-php.elogica.info';
  private readonly basicUser = '3l0g1k4';
  private readonly basicPass = 'dtr5x8!qAa6>';

  localStorage: LocalStorage = new LocalStorage();
  headers = new HttpHeaders();
  url_acesso: string;
  cabecalho: any;

  filial: string = '1';
  sigla: string = 'SGL';
  usuario: string = 'USUARIO';
  loginUsuario: string = 'LoginUsuario'

  constructor(private http: HttpClient, private acesso: AcessoService) {
    this.url_acesso = this.acesso.validarUrl();

    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);
      this.filial = this.localStorage.FilialAtual?.toString() || this.filial;
      this.sigla = this.localStorage.Sigla || this.sigla;
      this.usuario = (this.localStorage as any).CodigoUsuario || this.usuario;
      this.loginUsuario =this.localStorage.LoginUsuario
    } else {
      this.cabecalho = this.headers;
    }
  }

  private getCabecalhoRelatorios() {
    const credentials = btoa(`${this.basicUser}:${this.basicPass}`);
    return new HttpHeaders({
      'Authorization': `Basic ${credentials}`,
      'Content-Type': 'application/json'
    });
  }

  listar(sigla: string, dtComp: string, codBeneficio: number, filial: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.relatoriosBase}/vale-transporte/listar/${sigla}/${dtComp}/${filial}/${codBeneficio}`,
      { headers: this.getCabecalhoRelatorios() }
    );
  }

  listarHistoricoCompraBeneficio(anoMes: string, codigoBeneficio: number): Observable<any> {
    const sigla = this.sigla;
    const filial = this.filial;
    
    const url = `${this.relatoriosBase}/vale-transporte/listar-compra-beneficio/${sigla}/${anoMes}/${filial}`;

    return this.http.get<any>(url, { headers: this.getCabecalhoRelatorios() });
  }

  listarDetalheCompraBeneficio(anoMes: string, codigo: number): Observable<any> {
    const sigla = this.sigla;
    const filial = this.filial;
    
    const url = `${this.relatoriosBase}/vale-transporte/listar-compra-beneficio/${sigla}/${anoMes}/${filial}/${codigo}`;

    return this.http.get<any>(url, { headers: this.getCabecalhoRelatorios() });
  }



  listarItensCompraBeneficio(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.url_acesso}vale-transporte/listar-item-compra-beneficio`,
      { headers: this.cabecalho }
    );
  }

  listarItensCompraBeneficioPorCompra(codCompraBeneficio: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.url_acesso}vale-transporte/listar-item-compra-beneficio/${codCompraBeneficio}`,
      { headers: this.cabecalho }
    );
  }

  listarItemPorNumOrd(numOrd: number): Observable<any> {
    return this.http.get<any>(
      `${this.url_acesso}vale-transporte/listar-item-compra-beneficio-id/${numOrd}`,
      { headers: this.cabecalho }
    );
  }

  listarItemPorNumOrdDaCompra(numOrd: number, codCompraBeneficio: number): Observable<any> {
    return this.http.get<any>(
      `${this.url_acesso}vale-transporte/listar-item-compra-beneficio-id/${numOrd}/${codCompraBeneficio}`,
      { headers: this.cabecalho }
    );
  }




  atualizarItemCompra(body: AtualizarItemRequest): Observable<any> {
    const url = `${this.relatoriosBase}/vale-transporte/item-compra-beneficio`;
    return this.http.put(url, body, { headers: this.getCabecalhoRelatorios() });
  }

  excluirItemCompra(codigoCompra: number, numOrd: number): Observable<any> {
    const sigla = this.sigla;
    const url = `${this.relatoriosBase}/vale-transporte/item-compra-beneficio/${sigla}/${codigoCompra}/${numOrd}`;
    return this.http.delete(url, { headers: this.getCabecalhoRelatorios() });
  }

  inserirCompraBeneficioCompleto(compra: CompraBeneficioCompleto): Observable<any> {
    return this.http.post(
      `${this.relatoriosBase}/vale-transporte/inserir-compra-beneficio`,
      compra,
      { headers: this.getCabecalhoRelatorios() }
    );
  }

  listarBeneficios(): Observable<any> {

    const sigla = this.sigla;
    const filial = this.filial;
    
    const url = `${this.relatoriosBase}/vale-transporte/listar-beneficio/${sigla}/${filial}`;

    return this.http.get<any>(url, { headers: this.getCabecalhoRelatorios() });
  }

}